import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, "Dokument", -1)
const _hoisted_3 = { class: "card card-feat" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-light py-2 mb-3" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Här kan du ladda upp dokument mot banken. Klicka på frågetecknet för att se vad dokumentet ska innehålla. ")
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, " Du kommer kunna börja ladda upp dokument när du har valt bank. ", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "För tillfället finns det inga dokument att visa.", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MortgageTopMenu = _resolveComponent("MortgageTopMenu")!
  const _component_OfferDocuments = _resolveComponent("OfferDocuments")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createVNode(_component_MortgageTopMenu, {
        showFoundProperty: 
          _ctx.app.purpose == 'PromissoryLetter' || _ctx.app.findProperty
        ,
        showMortgageCalculator: _ctx.app.showMortgageCalculationForActiveApp,
        active: "Dokument"
      }, null, 8, ["showFoundProperty", "showMortgageCalculator"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.app && _ctx.app.offers)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.sortedDocuments.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDocuments, (document) => {
                      return (_openBlock(), _createElementBlock("div", {
                        style: {"margin-bottom":"30px","margin-top":"-25px pb-2"},
                        key: document.id
                      }, [
                        _createVNode(_component_OfferDocuments, {
                          item: document,
                          app: _ctx.app,
                          onUpdate: _ctx.update
                        }, null, 8, ["item", "app", "onUpdate"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
      ])
    ])
  ]))
}